import React, { Component, Fragment } from 'react';
import { isEmpty } from "lodash";
import { Grid, IconButton, FormControl, Select, InputLabel, MenuItem, OutlinedInput, Button, TextField, FormHelperText } from '@mui/material';

import FileUpload from '../../common/FileUpload';
import DatePicker from '../../common/DatePicker';
import Dialog from '../../common/Dialog';

class SuppliersAdvanceForm extends Component {
    state = { 
        advance_supplier_id: "",
        advance_ref: "",
        advance_date: new Date(),
        advance_id: "",
        advance_payment_mode: "",
        advance_bank: "",
        advance_amount: "",
        advance_files: null,
        
        errors: {
            advance_supplier_id: "",
            advance_ref: "",
            advance_date: "",
            advance_payment_mode: "",
            advance_bank: "",
            advance_amount: "",
            advance_files: "",
        },
        advanceList: [],
        available: ""
        
    }
    
    handleChange = (e) => {
        const { name, value} = e.target;
        
        this.setState({
            [name]: value
        })
        console.log('================= HANDLE CHANGE ===================');
        console.log('====================================');
    }
    handleChangeDate = (date) => {
        
        this.setState({
            advance_date: date
        })
    }
    handleChangeRef = (e) => {
        const { CREDITS } = this.props;
        const { name, value } = e.target;
        let advance = CREDITS[value]

        this.setState({
            [name]: advance.advance_ref,
            advance_id: value,
            available: advance.advance_total_available
        })
        
    }

    setFiles = (advance_files, error = "") => {
        console.log("[INFO] SET_PHOTO", advance_files);
        this.setState({
            advance_files,
            errors:{
                ...this.state.errors,
                advance_files:error
            }
        })
    }
    validate = () => {
        let required = [
            "advance_supplier_id",
            "advance_amount",
            "advance_ref",
            "advance_payment_mode",
            "advance_bank",
            // "advance_date",
            "advance_files"
        ]
        let noError = true
        let errors = {}
        

        required.map(field => {
            if( isEmpty(this.state[field]) || !this.state[field]) { // isEmpty doesn't work on dates, !doesn't work for arrays
                console.log(`${field} is empty`)
                noError =  false
                errors[field] = "Veuillez remplir ce Champ" 
            } else {
                errors[field] = "" 
            }
        })

        
        this.setState({
            errors
        })
        
        return noError
    }
    handleSubmit = async () => {

        if( this.validate() ){
            let data = {}
            data.advance_amount =  parseFloat(this.state.advance_amount)
            data.advance_payment_mode =  this.state.advance_payment_mode
            data.advance_bank =  this.state.advance_bank
            data.advance_supplier_id =  this.state.advance_supplier_id
            data.advance_ref =  this.state.advance_ref
            data.advance_date =  this.state.advance_date
            data.advance_files =  this.state.advance_files
            // data.advance_op = "CREDIT"
            
            console.log('====================================');
            console.log("submit advance", {data});
            console.log('====================================');
            
            await this.props.newSupplierAdvance(data)

            // // if NoErrors ...
            if(this.props.STATE.advances.error){
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.advances.error}`)
            } else { 
                this.props.notif("success", "Enregistré")
                this.props.handleClose()
            }
        } else {
            this.props.notif("error", "Le formulaire contient des erreurs")
        }
    }
    
    render() {
        const { BANKS, SUPPLIERS } = this.props;
        const { advanceList } = this.state;
        console.log('====================================');
        console.log(this.state);
        console.log('====================================');
        return (
            <Dialog
                close={this.props.handleClose}
                fullWidth
                maxWidth= "sm"
                scroll="body"
                title="Acompte fournisseur"
                submitAction={this.handleSubmit}
            >
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <DatePicker  
                            id="advance_date" 
                            label="Date de Paiement" 
                            name="advance_date" 
                            value={this.state.advance_date} 
                            handleChange={this.handleChangeDate} 
                            error={this.state.errors.advance_date}
                            required
                            noPadding
                        />      
                    </Grid>     
                    <Grid item xs={12} >
                        <FormControl variant="outlined"  error={!!this.state.errors.advance_bank} style={{width: "100%"}}>
                            <InputLabel htmlFor="advance_supplier_id">Fournisseur</InputLabel>
                            <Select
                                native
                                onChange={this.handleChange}
                                error={!!this.state.errors.advance_supplier_id}
                                value={this.state.advance_supplier_id}
                                input={
                                    <OutlinedInput 
                                        labelWidth={60} 
                                        name="advance_supplier_id" 
                                        id="advance_supplier_id" 
                                    />
                                }
                            >
                                <option value="" />
                                { Object.values(SUPPLIERS).map( supplier  => (
                                    <option value={supplier.supplier_id} key={supplier.supplier_id}>
                                        {supplier.supplier_name}
                                    </option>
                                )) }
                            </Select>
                            {/* <FormHelperText>{supplier Account}</FormHelperText> */}
                            <FormHelperText>{this.state.errors.advance_supplier_id}</FormHelperText>
                        </FormControl>
                    </Grid>                
                    <Grid item xs={12}>
                        <FormControl variant="outlined" style={{ width:'100%'}}>
                            <TextField
                                onChange={this.handleChange}
                                required
                                id="advance_amount"
                                error={!!this.state.errors.advance_amount}
                                helperText={this.state.errors.advance_amount}
                                value={this.state.advance_amount}
                                name="advance_amount"
                                label="Montant de l'avance"
                                variant="outlined"  
                                type="number"          
                                style={{width:"100%"}}
                            />
                        </FormControl>
                        {this.state.available &&
                            <FormHelperText >Disponible {this.state.available}</FormHelperText>
                        }
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl variant="outlined" style={{ width:'100%'}}>
                            <TextField
                                onChange={this.handleChange}
                                required
                                id="advance_ref"
                                error={!!this.state.errors.advance_ref}
                                helperText={this.state.errors.advance_ref}
                                value={this.state.advance_ref}
                                name="advance_ref"
                                label="Référence"
                                variant="outlined"  
                                style={{width:"100%"}}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl required error={!!this.state.errors.advance_payment_mode} variant="outlined" style={{ width:'100%'}}>
                            <InputLabel htmlFor="advance_payment_mode">Mode de Paiement</InputLabel>
                            <Select
                                value={this.state.advance_payment_mode}
                                onChange={this.handleChange}
                                input={<OutlinedInput labelWidth={170} name="advance_payment_mode" id="advance_payment_mode" />}
                            >
                                <MenuItem value="ESPECES">ESPECES</MenuItem>
                                <MenuItem value="CHEQUE">CHEQUE</MenuItem>
                                <MenuItem value="PRELEVEMENT">PRELEVEMENT</MenuItem>
                                <MenuItem value="VIREMENT">VIREMENT</MenuItem>
                                <MenuItem value="GAB">GAB</MenuItem>
                                <MenuItem value="MOBILE MONEY">MOBILE MONEY</MenuItem>
                            </Select>
                            <FormHelperText >{this.state.errors.advance_payment_mode}</FormHelperText>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} >
                        <FormControl variant="outlined"  error={!!this.state.errors.advance_bank} style={{width: "100%"}}>
                            <InputLabel htmlFor="advance_bank">Banque</InputLabel>
                            <Select
                                native
                                onChange={this.handleChange}
                                error={!!this.state.errors.advance_bank}
                                value={this.state.advance_bank}
                                input={
                                    <OutlinedInput 
                                        labelWidth={60} 
                                        name="advance_bank" 
                                        id="advance_bank" 
                                    />
                                }
                            >
                                <option value="" />
                                { Object.values(BANKS).map( bank  => (
                                    <option value={bank.bank_id} key={bank.bank_id}>
                                        {bank.bank_name}
                                    </option>
                                )) }
                            </Select>
                            <FormHelperText>{this.state.errors.advance_bank}</FormHelperText>
                        </FormControl>
                    </Grid>        
                    <Grid item xs={12}>
                        <FileUpload
                            label="Ajouter une Photo"
                            setFiles={this.setFiles} 
                            files={this.state.advance_files || []} 
                        />
                        <FormControl error={!!this.state.errors.advance_files} >
                            <br/>
                            <FormHelperText >{this.state.errors.advance_files}</FormHelperText>
                        </FormControl>
                    </Grid>                                                                                                                                         
                </Grid>
                
                {/* <DialogActions>
                    <Button variant="contained" onClick={this.handleSubmit} color="secondary">
                        Créditer
                    </Button>
                    <Button onClick={this.props.handleClose} >
                        Annuler
                    </Button>
                </DialogActions> */}
            </Dialog>
        );
    }
}

export default SuppliersAdvanceForm;